/** 
 * Fancybox init 
 */
jQuery(document).ready(function ($) {
    $('.has-fancybox').each(function () {
            var elem = $(this);
            elem.wrap('<a></a>');
            elem.closest('a').attr('data-src', elem.attr('src'));
            elem.closest('a').attr('data-fancybox', 'images');
            elem.closest('a').attr('data-animation-effect', 'fade');
            elem.closest('a').addClass('skip-lazy')
        
    });
    $('[data-fancybox="images"]').fancybox();
});
